<lib-ngx-uaa-profile-detail></lib-ngx-uaa-profile-detail>
